import { usePaymentProcessor } from "auth/usePaymentProcessor";

/** Determine whether we are allowed to submit partial refunds. */
export function useSubmitPartialRefunds() {
    const isStripe = usePaymentProcessor() === "Stripe";

    return isStripe;
}
